// frontend/src/components/PresupuestoModal.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import AreaItem from './AreaItem';
import CrearAreaModal from './CrearAreaModal';
import CrearOrdenCompraModal from './CrearOrdenCompraModal';
import '../styles/modals.css';
import './PresupuestoModal.css';

import Loading from './Loading';
const PresupuestoModal = ({ presupuesto, onClose, onUpdate }) => {
  const [presupuestoData, setPresupuestoData] = useState(presupuesto);
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCrearAreaModal, setShowCrearAreaModal] = useState(false);
  const [showOrdenCompraModal, setShowOrdenCompraModal] = useState(false);
  const [recursoPreseleccionado, setRecursoPreseleccionado] = useState(null);
  const [expandedAreas, setExpandedAreas] = useState({});

  useEffect(() => {
    cargarAreas();
  }, [presupuesto.id]);

  const cargarAreas = async () => {
    try {
      setLoading(true);
      const response = await presupuestosService.getPresupuestos();
      console.log('🔍 getPresupuestos response:', response.data);

      let presupuestosData = [];

      // Manejar respuesta paginada de Django REST Framework
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        console.log('✅ Presupuestos (paginado):', response.data.results.length);
        presupuestosData = response.data.results;
      }
      // Manejar respuesta directa de array
      else if (Array.isArray(response.data)) {
        console.log('✅ Presupuestos (array directo):', response.data.length);
        presupuestosData = response.data;
      }
      // Error: estructura no reconocida
      else {
        console.warn('⚠️ Presupuestos estructura no reconocida:', response.data);
        presupuestosData = [];
      }

      // Find the current presupuesto in the list
      const presupuestoEncontrado = presupuestosData.find(p => p.id === presupuesto.id);
      console.log('📍 Presupuesto encontrado:', presupuestoEncontrado?.id);
      console.log('📍 Presupuesto completo:', presupuestoEncontrado);
      console.log('📍 Presupuesto areas:', presupuestoEncontrado?.areas);
      console.log('📍 Tipos de campos en presupuesto:', Object.keys(presupuestoEncontrado || {}));

      if (presupuestoEncontrado) {
        setPresupuestoData(presupuestoEncontrado);
        const areasData = presupuestoEncontrado.areas || [];
        console.log('✅ Areas cargadas:', areasData.length, areasData);
        setAreas(areasData);

        // Expandir todas las áreas por defecto
        const expanded = {};
        if (Array.isArray(areasData) && areasData.length > 0) {
          areasData.forEach(area => {
            expanded[area.id] = true;
          });
        }
        setExpandedAreas(expanded);
      } else {
        console.warn('⚠️ Presupuesto no encontrado en la lista:', presupuesto.id);
        setAreas([]);
        setExpandedAreas({});
      }
    } catch (error) {
      console.error('Error al cargar presupuesto:', error);
      toast.error('Error al cargar presupuesto');
    } finally {
      setLoading(false);
    }
  };

  const handleAddArea = async (areaData) => {
    try {
      console.log('📝 Agregando área al presupuesto:', presupuesto.id, 'area:', areaData.id);
      // Agregar el área al presupuesto
      const response = await presupuestosService.addAreaToPresupuesto(presupuesto.id, areaData.id);
      console.log('✅ Área agregada (response):', response);
      toast.success('Área agregada al presupuesto');
      setShowCrearAreaModal(false);
      console.log('🔄 Recargando áreas...');
      await cargarAreas();
    } catch (error) {
      console.error('❌ Error al agregar área:', error);
      toast.error('Error al agregar área');
    }
  };

  const handleRemoveArea = async (areaId) => {
    if (window.confirm('¿Estás seguro de que quieres remover esta área?')) {
      try {
        await presupuestosService.removeAreaFromPresupuesto(presupuesto.id, areaId);
        toast.success('Área removida del presupuesto');
        cargarAreas();
      } catch (error) {
        console.error('Error al remover área:', error);
        toast.error('Error al remover área');
      }
    }
  };

  const handleChangeStatus = async (newStatus) => {
    try {
      console.log('📝 Cambiando estado del presupuesto a:', newStatus);
      const response = await presupuestosService.changePresupuestoStatus(presupuesto.id, newStatus);
      console.log('✅ Estado cambiado:', response.data);
      toast.success(`Presupuesto enviado a aprobación`);
      // Actualizar presupuestoData con los datos nuevos
      setPresupuestoData(response.data);
    } catch (error) {
      console.error('❌ Error al cambiar estado:', error);
      toast.error('Error al cambiar estado del presupuesto');
    }
  };

  const handleApprovePresupuesto = async () => {
    try {
      console.log('✅ Aprobando presupuesto:', presupuesto.id);
      const response = await presupuestosService.approvePresupuesto(presupuesto.id);
      console.log('✅ Presupuesto aprobado:', response.data);
      toast.success('Presupuesto aprobado exitosamente');
      // Actualizar presupuestoData con los datos nuevos
      setPresupuestoData(response.data);
    } catch (error) {
      console.error('❌ Error al aprobar presupuesto:', error);
      toast.error('Error al aprobar presupuesto');
    }
  };

  const handleRejectPresupuesto = async () => {
    if (!window.confirm('¿Estás seguro de que quieres rechazar este presupuesto?')) {
      return;
    }
    try {
      console.log('❌ Rechazando presupuesto:', presupuesto.id);
      const response = await presupuestosService.rejectPresupuesto(presupuesto.id);
      console.log('❌ Presupuesto rechazado:', response.data);
      toast.warning('Presupuesto rechazado');
      // Actualizar presupuestoData con los datos nuevos
      setPresupuestoData(response.data);
    } catch (error) {
      console.error('❌ Error al rechazar presupuesto:', error);
      toast.error('Error al rechazar presupuesto');
    }
  };

  const toggleArea = (areaId) => {
    setExpandedAreas(prev => ({
      ...prev,
      [areaId]: !prev[areaId]
    }));
  };

  const handleAbrirOrdenCompra = (recurso, partida, area) => {
    setRecursoPreseleccionado({
      recurso,
      partida,
      area
    });
    setShowOrdenCompraModal(true);
  };

  const handleCerrarOrdenCompra = () => {
    setShowOrdenCompraModal(false);
    setRecursoPreseleccionado(null);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-xl presupuesto-modal-content" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="presupuesto-header-content">
            <h1>{presupuestoData.nombre_presupuesto}</h1>
            <span className={`status-badge status-${presupuestoData.status}`}>
              {presupuestoData.status}
            </span>
          </div>
          <div className="presupuesto-header-actions">
            {presupuestoData.status === 'borrador' && (
              <button
                className="btn-primary"
                onClick={() => handleChangeStatus('enviado_aprobacion')}
                title="Enviar a aprobación"
              >
                📤 Enviar a Aprobación
              </button>
            )}
            {presupuestoData.status === 'enviado_aprobacion' && (
              <>
                <button
                  className="btn-approve"
                  onClick={handleApprovePresupuesto}
                  title="Aprobar presupuesto"
                >
                  ✅ Aprobar
                </button>
                <button
                  className="btn-reject"
                  onClick={handleRejectPresupuesto}
                  title="Rechazar presupuesto"
                >
                  ❌ Rechazar
                </button>
              </>
            )}
            <button
              className="modal-close-btn"
              onClick={onClose}
              title="Cerrar"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Info del presupuesto */}
        <div className="presupuesto-info">
          <div className="info-item">
            <span className="label">Equipo:</span>
            <span className="value">{presupuestoData.equipo_nombre}</span>
          </div>
          <div className="info-item">
            <span className="label">Período:</span>
            <span className="value">{presupuestoData.periodo}</span>
          </div>
          <div className="info-item">
            <span className="label">Consumido:</span>
            <span className="value">${presupuestoData.presupuesto_consumido.toLocaleString('es-CL')}</span>
          </div>
          <div className="info-item">
            <span className="label">Total:</span>
            <span className="value">${presupuestoData.total_presupuesto.toLocaleString('es-CL')}</span>
          </div>
          <div className="info-item">
            <span className="label">Diferencia:</span>
            <span className={`value ${presupuestoData.diferencia_presupuestaria >= 0 ? 'positive' : 'negative'}`}>
              ${presupuestoData.diferencia_presupuestaria.toLocaleString('es-CL')}
            </span>
          </div>
          <div className="info-item">
            <span className="label">Utilizado:</span>
            <span className="value">{presupuestoData.porcentaje_utilizado.toFixed(1)}%</span>
          </div>
        </div>

        {/* Barra de progreso */}
        <div className="progress-section">
          <div className="progress-bar">
            <div
              className={`progress-fill ${presupuestoData.porcentaje_utilizado > 100 ? 'over' : 'normal'}`}
              style={{ width: `${Math.min(presupuestoData.porcentaje_utilizado, 100)}%` }}
            ></div>
          </div>
        </div>

        {/* Areas */}
        <div className="presupuesto-modal-body">
          <div className="areas-header">
            <h2>📋 Áreas ({areas.length})</h2>
            {presupuestoData.status !== 'aprobado' && (
              <button
                className="btn btn-small btn-primary"
                onClick={() => setShowCrearAreaModal(true)}
                title={presupuestoData.status === 'aprobado' ? 'No puedes agregar áreas a un presupuesto aprobado' : 'Agregar área'}
                disabled={presupuestoData.status === 'aprobado'}
              >
                ➕ Agregar Área
              </button>
            )}
          </div>

          {loading ? (
            <Loading fullScreen={false} />
          ) : areas.length === 0 ? (
            <div className="empty-areas">
              <p>📭 No hay áreas asignadas a este presupuesto</p>
              {presupuestoData.status !== 'aprobado' && (
                <button
                  className="btn btn-primary"
                  onClick={() => setShowCrearAreaModal(true)}
                >
                  Agregar Área
                </button>
              )}
              {presupuestoData.status === 'aprobado' && (
                <p style={{ color: '#ef4444', fontSize: '0.9rem', marginTop: '0.5rem' }}>
                  ⚠️ No puedes agregar áreas a un presupuesto aprobado
                </p>
              )}
            </div>
          ) : (
            <div className="areas-list">
              {Array.isArray(areas) && areas.map(area => (
                <AreaItem
                  key={area.id}
                  area={area}
                  isExpanded={expandedAreas[area.id]}
                  onToggle={() => toggleArea(area.id)}
                  onRemove={() => handleRemoveArea(area.id)}
                  onUpdate={cargarAreas}
                  isAprobado={presupuestoData.status === 'aprobado'}
                  presupuestoId={presupuestoData.id}
                  presupuestoStatus={presupuestoData.status}
                  onAbrirOrdenCompra={handleAbrirOrdenCompra}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal para agregar área */}
      {showCrearAreaModal && (
        <CrearAreaModal
          presupuestoId={presupuesto.id}
          onClose={() => setShowCrearAreaModal(false)}
          onAreaAdded={handleAddArea}
        />
      )}

      {/* Modal para crear orden de compra */}
      {showOrdenCompraModal && (
        <CrearOrdenCompraModal
          onClose={handleCerrarOrdenCompra}
          onCreate={() => {
            handleCerrarOrdenCompra();
            cargarAreas();
          }}
          recursoPreseleccionado={recursoPreseleccionado}
          presupuestoId={presupuestoData.id}
        />
      )}
    </div>
  );
};

export default PresupuestoModal;
